import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import PerformanceReportLayer from "../components/PerformanceReportLayer";

const PerformanceReportPage = () => {
    return (
        <MasterLayout>
            <PerformanceReportLayer />
        </MasterLayout>
    );
};

export default PerformanceReportPage;
